import { parseResourceFileToObj } from '&/utils/common';

const modulesFiles = require.context('@/locales/zh-CN', true, /\.js$/);

const lang = parseResourceFileToObj(modulesFiles);

export default lang;
